// This file is auto-generated by @hey-api/openapi-ts

export const $SpApiError = {
    type: 'object',
    properties: {
        status: {
            type: 'number',
            example: 500
        },
        description: {
            type: 'string',
            example: 'Internal server error',
            description: 'Can be a user-friendly message or a standard HTTP message'
        }
    },
    required: ['status', 'description']
} as const;

export const $SpApiErrorResponse = {
    type: 'object',
    properties: {
        error: {
            nullable: false,
            allOf: [
                {
                    '$ref': '#/components/schemas/SpApiError'
                }
            ]
        }
    },
    required: ['error']
} as const;

export const $ProspectDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            example: '8a6e0804-2bd0-4672-b79d-d97027f9071a'
        },
        name: {
            type: 'string',
            example: 'John Doe'
        },
        jobTitle: {
            type: 'string',
            example: 'Software Engineer'
        },
        country: {
            type: 'string',
            example: 'Germany'
        },
        linkedInProfile: {
            type: 'string',
            example: 'https://www.linkedin.com/in/johndoe'
        },
        profilePicture: {
            type: 'string',
            example: 'https://s3.amazonaws.com/media.mixrank.com/profilepic/123456789',
            nullable: true
        },
        firstName: {
            type: 'string',
            example: 'John'
        },
        lastName: {
            type: 'string',
            example: 'Doe'
        },
        departments: {
            example: ['master_marketing'],
            type: 'array',
            items: {
                type: 'string'
            }
        },
        seniority: {
            type: 'string',
            example: 'c_suite',
            nullable: true
        }
    },
    required: ['id', 'name', 'jobTitle', 'country', 'linkedInProfile', 'profilePicture', 'firstName', 'lastName', 'departments', 'seniority']
} as const;

export const $PaginationDto = {
    type: 'object',
    properties: {
        start: {
            type: 'number',
            example: 1
        },
        next: {
            type: 'number',
            example: 11
        },
        total: {
            type: 'number',
            example: 120
        }
    },
    required: ['start', 'next', 'total']
} as const;

export const $MetaDto = {
    type: 'object',
    properties: {
        pagination: {
            '$ref': '#/components/schemas/PaginationDto'
        }
    },
    required: ['pagination']
} as const;

export const $FindAllProspectsByParamsOutputDto = {
    type: 'object',
    properties: {
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ProspectDto'
            }
        },
        meta: {
            '$ref': '#/components/schemas/MetaDto'
        }
    },
    required: ['items', 'meta']
} as const;

export const $GetUserCreditBalanceOutputDto = {
    type: 'object',
    properties: {
        value: {
            type: 'number',
            example: 100,
            description: 'Current user balance'
        },
        maxCredits: {
            type: 'number',
            example: 1000,
            description: 'Maximum credits that can be held by the user'
        }
    },
    required: ['value', 'maxCredits']
} as const;

export const $DebugDeleteProspectFromSequenceInput = {
    type: 'object',
    properties: {
        sequenceId: {
            type: 'string',
            example: '6d36b262-879c-44b3-ab0d-f1483b5d6446',
            description: 'The sequence ID to remove the prospect from'
        },
        prospectEmail: {
            type: 'string',
            example: 'hello@salesport.io',
            description: 'The prospect email to remove from the sequence'
        }
    },
    required: ['sequenceId', 'prospectEmail']
} as const;

export const $PerformLookupOutputDto = {
    type: 'object',
    properties: {
        processedProspectIds: {
            example: ['6d36b262-879c-44b3-ab0d-f1483b5d6446', '6d36b262-879c-44b3-ab0d-f1483b5d6447'],
            description: 'The prospect IDs that were successfully processed and enriched',
            type: 'array',
            items: {
                type: 'string'
            }
        },
        unprocessedProspectIds: {
            example: ['6d36b262-879c-44b3-ab0d-f1483b5d6446', '6d36b262-879c-44b3-ab0d-f1483b5d6447'],
            description: 'The prospect IDs that were not processed and enriched due to errors or incosistencies',
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: ['processedProspectIds', 'unprocessedProspectIds']
} as const;

export const $PerformLookupProspectInputDtoV2 = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            example: '8a6e0804-2bd0-4672-b79d-d97027f9071a'
        },
        name: {
            type: 'string',
            example: 'John Doe'
        },
        jobTitle: {
            type: 'string',
            example: 'Software Engineer'
        },
        country: {
            type: 'string',
            example: 'Germany'
        },
        linkedInProfile: {
            type: 'string',
            example: 'https://www.linkedin.com/in/johndoe'
        },
        profilePicture: {
            type: 'string',
            example: 'https://s3.amazonaws.com/media.example.com/profilepic/123456789',
            nullable: true
        },
        departments: {
            example: ['master_operations', 'master_marketing'],
            type: 'array',
            items: {
                type: 'string'
            }
        },
        seniority: {
            type: 'string',
            example: 'c_suite',
            nullable: true
        },
        firstName: {
            type: 'string',
            example: 'John'
        },
        lastName: {
            type: 'string',
            example: 'Doe'
        }
    },
    required: ['id', 'name', 'jobTitle', 'country', 'linkedInProfile', 'profilePicture', 'departments', 'seniority', 'firstName', 'lastName']
} as const;

export const $PerformLookupInputDtoV2 = {
    type: 'object',
    properties: {
        prospects: {
            description: 'List of prospects with detailed information.',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PerformLookupProspectInputDtoV2'
            }
        },
        forceLookupByLinkedIn: {
            type: 'boolean',
            description: 'Force lookup using LinkedIn profile URL instead of other methods',
            example: false,
            default: false
        }
    },
    required: ['prospects']
} as const;

export const $FindEmailFromLinkedinWebhookResponse = {
    type: 'object',
    properties: {}
} as const;

export const $ApolloWebhookResponse = {
    type: 'object',
    properties: {}
} as const;